<div class="input-group flex-nowrap">
  <input
    mat-input
    class="form-control"
    type="search"
    [(ngModel)]="searchTerm"
    (input)="search()"
    placeholder="Cerca..."
  />
</div>
